module.exports = __webpack_public_path__ + "img/hr.b5443518.svg";